import { NavLink } from 'react-router'

interface ManageClubButtonProps {
  clubId?: string
  isVisible: boolean
  state?: unknown
}

const ManageClubButton = ({ clubId, isVisible, state }: ManageClubButtonProps) => {
  if (!isVisible || !clubId) {
    return null
  }

  return (
    <NavLink
      to={`/club/${clubId}/admin`}
      state={state}
      className="md:absolute md:-top-[79px] md:right-0 -mt-[15px] mb-[25px] md:mt-0 md:mb-0 inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">
      Club Admin
    </NavLink>
  )
}

export default ManageClubButton
